import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuditsListPage } from './AuditsListPage';
import { AuditEditPage } from './AuditEditPage';

export function AuditsPage({ isExpanded }) {
  const location = useLocation();

  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<AuditsListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<AuditEditPage isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<AuditEditPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

AuditsPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};